<template>
  <div class="base-nav">
    <b-navbar toggleable="sm" type="dark" class="varr p-4">
      <div class="nav-wrapper" style="min-height: 50px" :class="[this.$route.name == 'testhall' ? 'smnav' : '']">
        <b-link
          v-if="
            (this.$route.name == 'select' ||
            this.$route.name == 'upgrade' ||
            this.$route.name == 'submitted') && entryType != 'portal'
          "
          :to="{ name: 'dashhome' }"
          class="dbl"
        >
          <b-icon-arrow-left font-scale="2" class="mr-3"></b-icon-arrow-left>
        </b-link>
        <b-navbar-brand
          v-if="entryType == 'platform'"
          :class="[
            $route.name == 'select' ? 'smmd' : '',
            $route.name == 'testhall' ? 'smlogo mx-auto mx-lg-0' : '',
          ]"
        >
          <b-link :to="{ name: 'dashhome' }">
            <img src="@/assets/logo.png" class="logo ml-lg-5" />
          </b-link>
        </b-navbar-brand>
        <div
          v-if="entryType == 'portal'"
          class="logo-tp d-flex justify-content-center align-items-middle justify-items-center"
          style="gap: 20px"
        >
          <img
            :src="org_details?.logo"
            style="max-width: 60px; max-height: 60px"
            class="logo w-8 h-8 ml-lg-5"
          />
          <p style="font-size: 20px; font-style: italic" class="mt-3">
            {{ org_details.organization_name }}
          </p>
        </div>
      </div>
    </b-navbar>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  methods: {
    ...mapActions(["logOut"]),
    logout() {
      if (confirm("Are you sure you want to log out? Saved Changes may be lost")) {
        this.logOut().then(() => {
          this.$router.push({
            name: "login",
          });
        });
      }
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      entryType: (state) => state.loginmaster.entryType,
      loggedin: (state) => state.loginmaster.loggedIn,
      org_details: (state) => state.loginmaster.org_details,
      environ: (state) => state.loginmaster.environ,
      origin: (state) => state.loginmaster.api_origin,
    }),
  },
};
</script>

<style scoped>
.nana {
  background-color: #263056;
}

.varr {
  background-color: white;
  display: flex;
}

.nav-links {
  padding: 10px;
  text-align: center;
  margin-left: 50vw;
}

.dbl {
  color: black;
}

.logo {
  width: 200px;
}

.aroute {
  font-weight: bolder;
  padding: 10px;
  text-decoration: none;
  color: #263056;
}

.aroute:active {
  color: #42b983;
}

.qui {
  background-color: #263056;
  color: white;
  font-weight: bold;
  border-radius: 10px 0px 0px 10px;
  text-align: right;
}

.tes {
  background-color: rgb(250, 227, 127);
  color: #263056;
  font-weight: bolder;
  border-radius: 0px 10px 10px 0px;
  text-align: left;
}

.nav-wrapper {
  display: flex;
  width: 80%;
}

.dbl {
  width: 20%;
  margin-top: 10px;
}

.smmd {
  width: 80%;
}

.logdrop {
  width: 20%;
}

.setbtn {
  background-color: white;
  border: 0px solid black;
}

.setbtn:active {
  border: 0px solid black;
}

@media (max-width: 999px) {
  .logo {
    width: 120px;
  }
  .smnav {
    height: 60px;
  }
  .smlogo {
    text-align: center;
  }
}
</style>
